'use strict';

module.exports.getDigitReader = function (options) {
  if(options && options.runInChildProcess){
    return require('./digitreader2-master');
  } else {
    return require('./digits-band');
  }
}

module.exports.validatedReading = require('./readingValidation').validatedReading;


//////////////////
// WEBPACK FOOTER
// ./~/@smartvatten/digitreader2/index.js
// module id = 441
// module chunks = 0